export default __webpack_public_path__ + "static/media/corn_extrudate.1f64d5aa.png";